import { useEffect, useState } from 'react';
import { pickBy, isEqual } from 'lodash';
import { PaginationProps } from 'antd/es/pagination';
import { promotionServices } from 'services';
import {
  IPromotionRequest,
  IGetPromotionResquestParams,
  AnyObject,
  IApprovePromotionRequestPayload,
  IVoucher,
} from 'interfaces';
import { commonConstants } from 'constants/index';
import { defaultPage } from 'constants/pagination';
import { paginationHelpers } from 'helpers';

const { DEFAULT_PARAMS, DEFAULT_SIZE_CHANGER } = commonConstants;
const { mapPagerApiToAntdPager } = paginationHelpers;

const usePromotionRequest = () => {
  const [promotionRequest, setPromotionRequest] = useState<IPromotionRequest[]>(
    []
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [params, setParams] = useState<IGetPromotionResquestParams>(
    DEFAULT_PARAMS
  );
  const [paginationAnt, setPaginationAnt] = useState<PaginationProps>({
    ...DEFAULT_SIZE_CHANGER,
  });
  const [voucherCodeFilter, setVoucherCodeFilter] = useState<
    IPromotionRequest['listVoucherCanChooses']
  >([]);
  const [applicationSource, setApplicationSource] = useState<string[]>([]);
  const [selectedVoucheeForShop, setSelectedVoucherForShop] = useState<
    AnyObject
  >({});
  const [loadingApprove, setLoadingApprove] = useState<boolean>(false);

  const getPromotionRequests = async () => {
    try {
      setLoading(true);
      const res = await promotionServices.getListPromotionRequest(params);
      if (res && res.promotionRequests) {
        setPromotionRequest(res.promotionRequests);
        if (!isEqual(voucherCodeFilter, res.voucherCodeForFilter))
          setVoucherCodeFilter(res.voucherCodeForFilter);
        if (!isEqual(applicationSource, res.applicationSource))
          setApplicationSource(res.applicationSource);
        const { pagination } = res;
        const pager = mapPagerApiToAntdPager(pagination);
        setPaginationAnt(pager);
        //default selected in voucherCode
        let tmpSelectedVoucher: AnyObject = {};
        res.promotionRequests.forEach(promotionReq => {
          tmpSelectedVoucher[promotionReq.id] = {
            value: promotionReq.voucherCodeId,
            label: promotionReq.voucherCode,
          };
          setSelectedVoucherForShop(tmpSelectedVoucher);
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (pagination: PaginationProps) => {
    const newQueryParams = {
      ...params,
      page: pagination.current || params.page,
      pageSize: pagination.pageSize || params.pageSize,
    };
    setParams(newQueryParams);
  };

  const onSearch = (values: AnyObject) => {
    let query = {
      ...pickBy({ ...params, ...values }, e => {
        return (
          e !== '' && e !== undefined && e !== null && e !== commonConstants.ALL
        );
      }),
    };
    setParams({ ...query, page: defaultPage, pageSize: params.pageSize });
  };

  const onChangeVoucherOfShop = (promoId: number, voucher: AnyObject) => {
    setSelectedVoucherForShop(oldState => ({
      ...oldState,
      [promoId]: voucher,
    }));
  };

  const onApprovePromotionRequest = async (
    id: number,
    values: IApprovePromotionRequestPayload
  ) => {
    try {
      setLoadingApprove(true);
      await promotionServices.approvePromotionRequest(id, values);
    } finally {
      setLoadingApprove(false);
    }
  };

  useEffect(() => {
    getPromotionRequests().then();
  }, [params]);

  return {
    getPromotionRequests,
    promotionRequest,
    loading,
    handleTableChange,
    paginationAnt,
    onSearch,
    setLoading,
    applicationSource,
    voucherCodeFilter,
    selectedVoucheeForShop,
    onChangeVoucherOfShop,
    onApprovePromotionRequest,
    loadingApprove,
  };
};

const useVoucherCode = () => {
  const [voucherCodes, setVoucherCodes] = useState<IVoucher[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [loadingCreate, setLoadingCreate] = useState<boolean>(false);
  const getVouchers = async (shopId: number) => {
    try {
      setLoading(true);
      const res = await promotionServices.getVouchers({ shopId });
      setVoucherCodes(res.voucherCodes);
    } finally {
      setLoading(false);
    }
  };

  const registerPromotionProgram = async (
    shopId: number,
    voucherCodeId: number
  ) => {
    try {
      setLoadingCreate(true);
      await promotionServices.registerPromotionProgram({
        shopId,
        voucherCodeId,
      });
    } finally {
      setLoadingCreate(false);
    }
  };

  return {
    voucherCodes,
    loading,
    getVouchers,
    registerPromotionProgram,
    loadingCreate,
  };
};

export default {
  usePromotionRequest,
  useVoucherCode,
};
